import { __decorate } from "tslib";
import { Component } from 'decorators';
import template from './FixedFooter.view.html';
let FixedFooterComponent = class FixedFooterComponent {
};
FixedFooterComponent = __decorate([
    Component({
        controllerAs: '$ctrl',
        template,
        transclude: true,
    })
], FixedFooterComponent);
export { FixedFooterComponent };
